import React from "react";
import { useDispatch } from "react-redux";
import { useMeasuresAndDimensions, useCreateColManager } from "./insManagerDataExportGrid.setup";
import { prepareTagRows } from "components/tags/helpers";
import { useFetchTagsQuery } from "components/tags/tagsApi";
import { TagEntityType } from "components/tags/types";
import { InsGrid } from "components/widgets";
import { insDatapointGridWidgetAdapterData } from "components/widgets/grid/insDatapointGridWidgetAdapter";
import { useCustomDataDatapointsRequest, useGetCustomDataDatapoints } from "hooks/use-custom-data-datapoints";
import { setSelectedRowsState } from "store/grids";
export const InsManagersDataExportGrid = (props) => {
    const dispatch = useDispatch();
    const { dimensions, measures } = useMeasuresAndDimensions([]);
    const request = useCustomDataDatapointsRequest(dimensions, measures, props.stateId, "USD"), [data, querystate] = useGetCustomDataDatapoints(request);
    const cols = useCreateColManager();
    const { rows, totals } = insDatapointGridWidgetAdapterData(data, cols);
    const { data: tags } = useFetchTagsQuery({ entityType: TagEntityType.MANAGER });
    const newRows = prepareTagRows(rows, tags);
    return React.createElement(React.Fragment, null,
        React.createElement(InsGrid, { selectionMode: "multiple", rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({
                    id: props.stateId,
                    selectedRows: e.api.getSelectedRows()
                        .map((row) => `${row.Id}`)
                }));
            }), widgetId: props.stateId, stateId: props.stateId, columnDefs: cols, rowData: newRows, totalData: totals, queryState: querystate, suppressRowClickSelection: true }));
};
